import { useForm } from "react-hook-form";
import { postJsonHelper } from "../../../services/apiService/apiHelper";
import { endpoints } from "../../../services/apiService/endpoint";
import { useLoginContext } from "../context/LoginProvider";
import { replace, useNavigate } from "react-router-dom";
import { setUser } from "../../../features/auth/authSlice";
import { toast } from "react-toastify";

export const useLoginHook = () => {
  const { setButtonLoading, dispatch } = useLoginContext();
  // handle form submission and validation
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
  } = useForm();

  const navigate = useNavigate();

  // handle login form
  const loginSubmit = async (data) => {
    setButtonLoading(true);
    try {
      const response = await postJsonHelper(endpoints.login, data);

      if (response.data.status === true) {
        // Store the token in localStorage
        localStorage.setItem("token", response.data.access_token);

        // Manually handle token expiration (if needed)
        const expirationTime = new Date().getTime() + 3 * 60 * 60 * 1000; // 3 hours
        localStorage.setItem("token_expiration", expirationTime.toString());

        setButtonLoading(false);
        dispatch(setUser(response.data.data));
        reset();
        navigate("/admin/dashboard", { replace: true });
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message || "Something went wrong."); // Ensure message comes from data
        setButtonLoading(false);
      }
    } catch (err) {
      setButtonLoading(false);
      toast.error(err.message || "An error occurred");
      console.log(err, "login error");
    }
  };

  return {
    register,
    handleSubmit,
    watch,
    errors,
    loginSubmit,
  };
};
